/**
 * General component description.
 * You can even use the native Markdown here.
 * E.g.:
 * ```html
 * <StatBox foo={541} />
 * ```
 */

import React from 'react';
import { Card } from 'react-bootstrap';
import PropTypes from 'prop-types';

var StatBox = function StatBox(_ref) {
    var number = _ref.number,
        variant = _ref.variant,
        title = _ref.title,
        children = _ref.children,
        className = _ref.className,
        footerComponent = _ref.footerComponent;

    return React.createElement(
        Card,
        null,
        React.createElement(
            Card.Body,
            null,
            React.createElement(
                'p',
                { className: 'text-muted mb-0' },
                title
            ),
            React.createElement(
                'h1',
                { className: 'text-' + variant },
                number
            ),
            children
        ),
        footerComponent
    );
};

StatBox.defaultProps = {

    number: 0,
    variant: 'default',
    className: 'shadow rounded-0'
};
StatBox.propTypes = process.env.NODE_ENV !== "production" ? {
    /**
    * Value to show.
    */
    number: PropTypes.number.isRequired,
    /**
    * Color variants.
    */
    variant: PropTypes.oneOf(['default', 'primary', 'secondary', 'success', 'info', 'danger', 'warning']),
    /**
    * Stat title
    */
    title: PropTypes.string,
    className: PropTypes.string,
    footerComponent: PropTypes.oneOf([PropTypes.func, PropTypes.shape({
        $$typeof: PropTypes.symbol
    })])
} : {};
export default StatBox;